<template>
  <b-card class="mb-4" no-header>
    <b-row>
      <b-col cols="12">
        <div class="d-flex mb-3">
          <b-button-group class="add-button-group">
            <b-btn variant="primary" to="/repairs/create">Tambah Data</b-btn>
          </b-button-group>
          <div class="ml-auto" v-if="$store.getters['account/accountData'].role === Roles.ADMIN">
            <b-form-checkbox id="repair-with-trash" v-model="filter.with_trash" :value="1" :unchecked-value="null">
              Lihat Data Terhapus
            </b-form-checkbox>
          </div>
        </div>
      </b-col>
      <b-col cols="12" class="mb-4">
        <b-form @submit.prevent="doFilter">
          <b-row class="filter-row">
            <b-col cols="12" md="4">
              <form-group-input ref="filter-transaction_no" type="text" label="No. surat" :need-label="true" v-model="filter.transaction_no" id="filter-transaction_no" @keyup="filterTransactionNo" />
            </b-col>
            <b-col cols="12" md="4">
              <form-group-input type="text" label="Nama barang" :need-label="true" v-model="filter.nama_barang" id="filter-nama_barang" @keyup="filterNamaBarang" />
            </b-col>
            <b-col cols="12" md="4">
              <form-group-input type="date" label="Tanggal perbaikan" :need-label="true" v-model="filter.tanggal_perbaikan" id="filter-tanggal_perbaikan" />
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
    <paginated-table ref="dataTable" :data-url="apiUrl.repair" :data-columns="columns" :data-params="dataParams" :default-data-params="filter" data-order-field="tanggal_perbaikan" :data-order-asc="0" :can-delete="true" :can-edit="true" :can-edit-row="canAct" :can-delete-row="canDeleteRow" />
  </b-card>
</template>

<script>
import { debounce, Roles } from '@/_helpers'
import PaginatedTable from '@/components/PaginatedTable.vue'
import FormGroupInput from '@/components/FormGroupInput.vue'
import Repair from '@/models/Repair.js'

const repairModel = new Repair()

export default {
  components: { PaginatedTable, FormGroupInput },
  data () {
    return {
      Roles,
      apiUrl: { repair: repairModel.endpoint },
      columns: [
        { prop: 'transaction_no', label: 'No. Surat', sortable: true, resizable: true, minWidth: 140, wrapInLink: true, deletedDetailHere: true },
        { prop: 'tanggal_perbaikan', label: 'Tanggal', sortable: true, resizable: true, minWidth: 110, formatThisDate: true, align: 'center' },
        { prop: 'nama_barang', label: 'Nama Barang', sortable: true, resizable: true, minWidth: 180 },
        { prop: 'kadar', label: 'Kadar', resizable: true, minWidth: 90, align: 'center' },
        { prop: 'berat', label: 'Berat (gram)', sortable: true, resizable: true, minWidth: 110, isNumeric: true, align: 'right' },
        { prop: 'biaya_perbaikan', label: 'Biaya Perbaikan', sortable: true, resizable: true, minWidth: 140, needCurrency: true, align: 'right' }
      ],
      filter: {
        with_trash: this.$route.query.with_trash !== undefined ? parseInt(this.$route.query.with_trash) : null,
        transaction_no: this.$route.query.transaction_no || null,
        nama_barang: this.$route.query.nama_barang || null,
        tanggal_perbaikan: this.$route.query.tanggal_perbaikan || null
      },
      dataParams: ['with_trash', 'transaction_no', 'nama_barang', 'tanggal_perbaikan']
    }
  },
  watch: {
    'filter.with_trash': function () { this.doFilter() },
    'filter.tanggal_perbaikan': function () { this.doFilter() }
  },
  methods: {
    canAct (row) {
      const account = this.$store.getters['account/accountData']
      return account.role === Roles.ADMIN || Number(row.created_by) === Number(account.id)
    },
    canDeleteRow (row) {
      const account = this.$store.getters['account/accountData']
      return row.deleted_at ? account.role === Roles.ADMIN : this.canAct(row)
    },
    filterTransactionNo () { this.debounceFilter(this) },
    filterNamaBarang () { this.debounceFilter(this) },
    debounceFilter: debounce(vm => vm.doFilter(), 350),
    doFilter () { this.$refs.dataTable.doFilter(this.filter) }
  }
}
</script>
